import "./toast.css";
import ExclamationMarkCircle from "./ExclamationCircle";
const Toast = ({ messages }) => {
  return (
    <div className="w-full h-full absolute z-50 pt-[48px] pl-[352px] shadow-medium background-gradient">
      <div className="flex flex-col justify-center bg-grey-900 w-[1128px] min-h-[120px] pl-[54px] rounded-[8px] ">
        <ExclamationMarkCircle />

        <span className="pl-[46.4px] text-light-1 font-scaniacondensed text-xl space-y-2">
          {messages.map((msg, i) => (
            <div key={i}>{msg}</div>
          ))}
        </span>
      </div>
    </div>
  );
};

export default Toast;
